import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getUnit = (unitId: number | undefined): Promise<IGetUnitViaID> => {
  return axiosDefaultApi.get(`/api/Units/GetUnitsViaID/${unitId}`);
};

type QueryFnType = typeof getUnit;

type UseGetUnitOptions = {
  unitId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetUnit = ({ unitId , config }: UseGetUnitOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getUnit_${unitId}`],
    queryFn: () => getUnit(unitId),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση της Μονάδας.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};